import { useState, useEffect, useCallback } from 'react';

export const useDeviceBreakpoints = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTabletOrSmaller, setIsTabletOrSmaller] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  const updateDevice = useCallback(() => {
    const width = window.innerWidth;
    setIsMobile(width < 768);
    setIsTabletOrSmaller(width < 1024);
    setIsDesktop(width >= 1024);
  }, []);

  useEffect(() => {
    updateDevice();
    window.addEventListener('resize', updateDevice);
    return () => window.removeEventListener('resize', updateDevice);
  }, [updateDevice]);

  return { isMobile, isTabletOrSmaller, isDesktop };
};
